import { Reveal, Overline } from "./Reveal";
import { DIRECTOR } from "../lib/site";
import { scrollToId } from "../lib/scroll";
import { ArrowUpRight } from "lucide-react";

const ABOUT_IMG = "/jobs/site-pour.jpg";

export const About = () => (
  <section id="about" data-testid="about-section" className="scroll-mt-20 bg-lec-bone">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 md:grid-cols-12 md:px-10 md:py-28">
      <Reveal className="md:col-span-5">
        <div className="relative">
          <div className="absolute -bottom-4 -right-4 h-full w-full bg-lec-green" aria-hidden="true" />
          <img
            src={ABOUT_IMG}
            alt="The Leading Edge Concrete team mid-pour on a formed slab"
            loading="lazy"
            className="relative aspect-[4/5] w-full object-cover"
          />
          <div className="absolute left-4 top-4 bg-lec-ink px-4 py-3">
            <p className="font-display text-3xl font-semibold text-lec-green">25+</p>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-lec-bone/80">
              Years pouring
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="md:col-span-7 md:pl-8">
        <Overline>Who we are</Overline>
        <h2 className="mt-6 font-display text-4xl font-semibold tracking-tight text-lec-ink sm:text-5xl">
          Family-owned. Local <span className="underline decoration-lec-green decoration-8 underline-offset-8">through and through.</span>
        </h2>
        <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-lec-charcoal md:text-lg">
          <p>
            For over 25 years, the family-owned and operated team at Leading Edge Concrete has
            been providing exceptional value in decorative concreting solutions across Perth and
            its surrounding suburbs.
          </p>
          <p>
            Whether it be driveways, pool surrounds, patios, alfresco areas or pathways, we are
            trusted by the state's top builders and pool installers.
          </p>
          <p>
            With expertise across all facets of decorative concrete, we have a passion for what
            we do and a deep understanding of the most current designs and trends.
          </p>
          <p>
            Contact us today and enjoy the confidence of working with us from start to finish —
            without the inconvenience of any external contractors.
          </p>
        </div>
        <p className="mt-8 font-display text-xl font-semibold text-lec-ink">
          — {DIRECTOR}, <span className="text-lec-charcoal">Director</span>
        </p>
        <button
          data-testid="about-get-in-touch-button"
          onClick={() => scrollToId("#contact")}
          className="group mt-8 inline-flex items-center gap-2 border-b-2 border-lec-green pb-1 text-sm font-bold uppercase tracking-wider text-lec-ink transition-colors duration-200 hover:text-lec-green"
        >
          Get in Touch
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </button>
      </Reveal>
    </div>
  </section>
);
